import { Injectable } from '@angular/core';
import { map } from 'jquery';
import { BehaviorSubject, Subject } from 'rxjs';
import { Answer } from 'virtue-form';

@Injectable({
  providedIn: 'root'
})
export class EventDataService {
  public providerUniversityName = new Subject<string>();
  public isSetFaviconIcon = new Subject<string>();
  public isLogoUrl = new Subject<string>();
  public selectedUniversityList = new Subject<[]>();
  public mergedUniversityList = new Subject<[]>();
  organizationLoaded = new BehaviorSubject(false);//new Subject<boolean>();
  isFeedBackPreviousButtonClick = new BehaviorSubject(false);//new Subject<boolean>();
  isClearCollegeListClear = new BehaviorSubject(false);//new Subject<boolean>();
  answerMap = new BehaviorSubject<Map<Number,Answer>>(new Map());//new Subject<boolean>();
  public userFormFilledData = new Subject<any>();
  constructor() { }

  setProviderUniversityName(data:string) {
    this.providerUniversityName.next(data);
  }

  setFaviconIcon(data:string) {
    this.isSetFaviconIcon.next(data);
  }


  setLogo(data:string) {
    this.isLogoUrl.next(data);
  }
  setSelectedUniversityList(data: []) {
    this.selectedUniversityList.next(data);
  }

  setMergedUniversityList(data:any) {
    this.mergedUniversityList.next(data);
  }
  
  setUserFormFilledData(data: any) {
    this.userFormFilledData.next(data);
  }

  hanleOrganizationLoading(val: boolean){
    this.organizationLoaded.next(val);
  }

  hanleFeedBackPreviousbtn(val: boolean){
    this.isFeedBackPreviousButtonClick.next(val);
  }

  hanleAnswerMap(val: Map<Number,Answer>){
    this.answerMap.next(val);
  }


  clearCollegeListFilters(val: boolean)
  {
    this.isClearCollegeListClear.next(val);
  }



  // setCombineUniversityList(listOne,listTwo) {
  //   this.combinedUniversityList.next({listOne,listTwo});
  // }


}

